<template>
  <div>
    <div v-html="marketplaceIcon(mpId)"></div>
    <apexchart height="500" :options="chartOptions" :series="series" />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { marketplaceIcon } from "@/utils/helper";

export default {
  components: {
    apexchart: VueApexCharts
  },
  props: {
    chartOptions: Object,
    series: Array,
    mpId: String
  },
  methods: {
    marketplaceIcon(value) {
      return marketplaceIcon(value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/monitoring/summary/components/totalStatusPerMPB.vue